import React, { useState } from "react";
import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { login, updatePath } from "../../store/auth/auth";
import * as Yup from "yup";
import { AXIOS, api_key } from "../../config";
import Loader from "../loader/loader";
import { BsXCircle, BsXSquareFill } from "react-icons/bs";
import { MdEmail, MdSms } from "react-icons/md";
import Countdown from "react-countdown";
import "./login.css";
import { toast } from "react-toastify";

// const baseUrl = "https://9997-103-162-136-86.ngrok-free.app";
// const baseUrl = "https://cex.heed3patti.com";

export default function SignIn({ show, handleClose, data, email }) {
  console.log("data", data);
  // let obj={
  //   email:data.email,
  //   password:data.password,
  //   searchType:data.registerType,
  //   user_id:data.user_id,

  // }
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState<Boolean>(false);
  const [miliseconds, setMiliseconds] = useState(1);
  const pinSchema = Yup.object().shape({
    pin: Yup.string().required("pin is required"),
  });
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      pin: "",
    },
    validationSchema: pinSchema,

    onSubmit: async (values, action) => {
      setLoading(true);
      let newValues = {
        ...data,
        pin: values.pin,
        reason: "login_verification",
        api_key: api_key,
        searchType: data.registerType,
      };
      const res = await axios.get("https://api.ipify.org/?format=json");
      const config = {
        headers: {
          "client-ip": res.data.ip,
          "Content-Type": "application/json",
        },
      };
      await AXIOS.post(`/login`, newValues, config)
        .then((response) => {
          if (response.data.status == "success") {
            newValues = { user: response.data.data };
            dispatch(login(newValues));
            dispatch(updatePath("/"));
            navigate("/");

            toast.success("Successfully Login");
          } else {
            // navigate("/login");
            console.log("login failed");
            toast.error(response.data.showableMessage, {
              icon: <BsXSquareFill />,
            });
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          toast.error("Login Failed", { icon: <BsXSquareFill /> });
        });
      handleClose();
    },
  });
  const getCode = async () => {
    setMiliseconds(miliseconds + 1);

    try {
      let otpSent = await AXIOS.post(`/sendMail`, {
        api_key: api_key,
        user_id: data.user_id,
        reason: "login_verification",
      });
      toast.success("Pin code sent to Email", { icon: <MdEmail /> });
      console.log("otpsent", otpSent);
    } catch (error) {}
  };

  const Completionist = () => <span className="ver_grp_sp" onClick={getCode}>Get Code</span>;

  // Renderer callback with condition
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span className="ver_grp_sp">
          {minutes}:{seconds}
        </span>
      );
    }
  };
  return (
    <>
      <div className="container reg_verify">
        <div className="row align-items-center">
          <div className="col">
            <div className="verify mb-4">
              <h2>Security Verification</h2>
              <span className="verify_span">
                For your account security, please complete the following
                verification operations
              </span>
            </div>
            <Form onSubmit={formik.handleSubmit}>
              {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email verification</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                value={
                  userDetail.registerType == "email"
                    ? userDetail.data
                    : userDetail.phone
                }
                autoFocus
                disabled
              />
            </Form.Group> */}
              <Form.Group
                className="mb-3 ver_grp"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label className="verify_lbl">
                  Email Verification Code
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="0000"
                  autoFocus
                  name="pin"
                  value={formik.values.pin}
                  onChange={formik.handleChange}
                />
                <Form.Text style={{ color: "var(--text-clr)" }}>
                  Code will be sent to {email}
                </Form.Text>

                <div className="" onClick={getCode} >
                  <Countdown
                    key={miliseconds}
                    date={Date.now() + miliseconds * 60000}
                    renderer={renderer}
                  />
                  {/* <span>Get Code</span> */}
                </div>
              </Form.Group>
              {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="text"
                placeholder="..........."
                autoFocus
                disabled
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Example textarea</Form.Label>
              <Form.Control
                type="number"
                placeholder="Put some text"
                autoFocus
              />
            </Form.Group> */}
              {isLoading == false ? (
                <Button
                  type="submit"
                  className="w-100 fw-bold ver_btn"
                  disabled={formik.values.pin == ""}
                >
                  Submit
                </Button>
              ) : (
                <Button type="submit" className="w-100 fw-bold ver_btn">
                  {" "}
                  <Loader />
                </Button>
              )}
            </Form>
          </div>
        </div>
      </div>
      {/* <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="sign_modale">
          <BsXCircle
            className="btn-cross"
            style={{ color: "var(--text-clr)" }}
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Body className="sign_modale">
          <Form onSubmit={formik.handleSubmit}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label style={{ color: "var(--text-clr)" }}>
                Email address
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                value={data.user}
                autoFocus
                disabled
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label style={{ color: "var(--text-clr)" }}>Pin</Form.Label>
              <Form.Control
                type="text"
                placeholder="00000"
                autoFocus
                name="pin"
                value={formik.values.pin}
                onChange={formik.handleChange}
              />
            </Form.Group>
            {isLoading == false ? (
              <Button type="submit">Submit</Button>
            ) : (
              <Loader />
            )}
          </Form>
        </Modal.Body>
      </Modal> */}
    </>
  );
}
